import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import AcademyInterestForm from '../components/AcademyInterestForm';
import '../styles/ServiceEnquiry.css';

const AcademyRegisterInterest = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const requested = params.get('pathway');
  const defaultPathway = ['flight', 'rail', 'both'].includes(requested) ? requested : 'flight';

  return (
    <SubpageShell currentPath="/academy/register-interest">
      <SEO
        title="Register Interest — N3URO Academy"
        description="Register your interest in Flight Academy or Rail Academy. This is not a booking."
        canonical="/academy/register-interest"
      />
      <main className="subpage-hero">
        <nav aria-label="Breadcrumb" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', marginBottom: '0.5rem' }}>
          <Link to="/academy" style={{ color: '#5BE9FF' }}>Academy</Link> &middot; Register interest
        </nav>
        <span className="subpage-eyebrow">N3URO Academy</span>
        <h1 className="subpage-title">Register your interest.</h1>
        <p className="subpage-lede">
          Share your preferred pathway, age band and format. We'll be in touch when places open. This
          is not a booking and no payment is taken.
        </p>
        <AcademyInterestForm defaultPathway={defaultPathway} />
      </main>
    </SubpageShell>
  );
};

export default AcademyRegisterInterest;
